// extracted by mini-css-extract-plugin
export default {"b-game-container":"bounce_b-game-container__SFrWm","b-canvas":"bounce_b-canvas__Qtu+U","b-game-controls":"bounce_b-game-controls__y9DQq"};